const Header = () => {

  return (


    <header id="header1" className="border">
      
      <div className="header-container">




        <h6 className="white">Junaid</h6>

        <div className="header-links-container">


          <a href="/" ><p className="sm headerlinks">Resume</p></a>
        </div>

      </div>

    </header>

  );
}

export default Header;